import { HeaderTitle, Icon, LinkText } from '@/components/atoms'
import { DynamicColumnTable } from '@/components/organisms'
import { getCellDataMappedCols } from '@/helpers/dataTableCellDataMapper'
import { useInventory } from '@/hooks/useInventory'
import { getSelectedRowData } from '@/utils/commons'
import { Header } from '@/utils/constants/header'
import { useState } from 'react'
import { UploadHistoryTableModal } from '@/components/organisms'
const cellDataMapperObj = {
  productId: ({ row: { original } = {} }) => {
    return (
      <div>
        <LinkText
          text={original?.productId}
          id={original?.productId + ' ' + original?.id}
          handleClick={() => {
            // navigate(ROUTES.BULK_POINT_MODIFIER_REVIEW)
          }}
        />
      </div>
    )
  },
}

/**
 * Column definitions for the sub-table
 */
const subColumns = [
  {
    columnKey: 'product_id',
    header: 'Product ID',
  },
  {
    columnKey: 'warehouse_id',
    header: 'Warehouse ID',
  },
  {
    columnKey: 'status',
    header: 'Status (REMARK)',
  },
]

/**
 * Column definitions for the main table
 */
const mainColumns = [
  { columnKey: 'file_path', header: 'FILE PATH' },
  { columnKey: 'import_date', header: 'IMPORT DATE' },
  { columnKey: 'job_start_date', header: 'JOB START DATE' },
  { columnKey: 'job_end_date', header: 'JOB END DATE' },
  {
    columnKey: 'total_records',
    header: 'STATISTICS',
    cellData: ctx => (
      <div className="flex flex-col">
        <div>{ctx.row.original.total_records}</div>
        {ctx.row.original.failed_records_count > 0 && (
          <div className={`failed-tests ${ctx.row.original.id}`} style={{ color: 'red', fontWeight: 'bold' }}>
            {ctx.row.original.failed_records_count} Failed
          </div>
        )}
      </div>
    ),
  },
]

const Inventory = () => {
  // const navigate = useNavigate()
  const [openUploadHistory, setOpenUploadHistory] = useState(false)

  const [rowSelected, setRowSelected] = useState([])
  const [isSelectAll, setIsSelectAll] = useState(false)

  const {
    inventoryData,
    inventoryColConfigData,
    inventoryUploadHistoryData,
    setPageIndex,
    setSortingObj,
    setSearchArry,
    onDownloadBtnClick,
  } = useInventory()
  const cellDataMappedCols = getCellDataMappedCols(cellDataMapperObj, inventoryColConfigData)

  const selectedDataList = getSelectedRowData(rowSelected, inventoryData?.data)
  const extractIds = () => (isSelectAll ? [] : selectedDataList?.map(item => item.productId))

  const onDownloadClick = async () => {
    onDownloadBtnClick(extractIds(), isSelectAll)
  }

  return (
    <div className="inventoryContainer flex flex-col">
      <div className="relative" style={{ backgroundColor: '#1D1D1D' }}>
        <HeaderTitle
          headingLevel={Header.SectionTitle}
          title="Inventory List"
          className="inventoryDataTableHeading  pl-4 pr-4"
        />
        <span className="inventorySettingsIcon absolute h-8 w-8 rounded p-2">
          <Icon icon="settings" isDark={true} size="small" className="h-4 w-4" />
        </span>

        {inventoryColConfigData?.length > 0 && inventoryData?.data && (
          <DynamicColumnTable
            columns={cellDataMappedCols || []}
            records={inventoryData?.data || []}
            rowSelection={rowSelected}
            setRowSelection={setRowSelected}
            enableSorting={true}
            pageSize={10}
            filters={false}
            toolbarActions={[
              {
                text: 'View Upload History',
                variant: 'secondary',
                onClick: () => {
                  setOpenUploadHistory(true)
                },
              },
              {
                iconLeading: <Icon icon="download" size="small" />,
                text: 'Download',
                variant: 'secondary',
                onClick: () => {
                  onDownloadClick()
                },
              },
            ]}
            showGlobalActions={false}
            setPageIndex={setPageIndex}
            setSearchArry={setSearchArry}
            setSortingObj={setSortingObj}
            setIsSelectAll={setIsSelectAll}
          />
        )}
        {inventoryData?.totalRecords && <div className="txtRightAlign">{inventoryData?.totalRecords} total items</div>}
      </div>
      <UploadHistoryTableModal
        openUploadHistory={openUploadHistory}
        setOpenUploadHistory={setOpenUploadHistory}
        mainData={inventoryUploadHistoryData}
        mainColumns={mainColumns}
        subData={(inventoryUploadHistoryData ?? []).flatMap(item =>
          (item.failed_records ?? []).map(record => ({
            ...record,
            parentId: item.id,
          }))
        )}
        subColumns={subColumns}
        isDark={true}
      />
    </div>
  )
}

export default Inventory
